// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

import { Link } from '@nerdwallet/currency';

// Local components
import AuthModal from '../../containers/auth-modal';
import {
  getEventType,
  getEventDetails,
  getEventEntityName,
  getCSOnboarding,
  REG_DRIVER_LOCATION,
} from '../../lib/analytics-constants';

const CreditScoreOnboardingCta = ({ closeOnboardingModal }) => {
  const getCSOnboardingEvent = getCSOnboarding();
  const getCSOnboardingDetails = getEventDetails(getCSOnboardingEvent);
  return (
    <AuthModal
      onSuccess={closeOnboardingModal}
      impressionPayload={{
        eventType: getEventType(getCSOnboardingEvent),
        entityName: getEventEntityName(getCSOnboardingEvent),
        payload: getCSOnboardingDetails,
      }}
      driverLocation={REG_DRIVER_LOCATION.ONBOARDING_GET_CREDIT_SCORE}
    >
      <Link>Not sure? Get your credit score</Link>
    </AuthModal>
  );
};

CreditScoreOnboardingCta.displayName = 'CreditScoreOnboardingCta';

CreditScoreOnboardingCta.propTypes = {
  closeOnboardingModal: PropTypes.func,
};

CreditScoreOnboardingCta.defaultProps = {
  closeOnboardingModal: () => {},
};

export default CreditScoreOnboardingCta;
